// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LocationPathField_GetLocationsQueryVariables = Types.Exact<{
  filter: Types.LocationsFilter;
}>;


export type LocationPathField_GetLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string }, room?: { __typename?: 'Location', id: string, roomType?: { __typename?: 'RoomType', id: string } | null | undefined } | null | undefined, level?: { __typename?: 'Location', id: string } | null | undefined, group?: { __typename?: 'Location', id: string } | null | undefined, featureType?: { __typename?: 'FeatureType', id: string } | null | undefined }> };

export type LocationPathField_GetFeatureTypesQueryVariables = Types.Exact<{
  filter: Types.FeatureTypesFilter;
}>;


export type LocationPathField_GetFeatureTypesQuery = { __typename?: 'Query', featureTypes: Array<{ __typename?: 'FeatureType', id: string, name: string, parent?: { __typename?: 'FeatureType', id: string } | null | undefined }> };

export type LocationPathField_FeatureTypeFragment = { __typename?: 'FeatureType', id: string, name: string, parent?: { __typename?: 'FeatureType', id: string } | null | undefined };

export type LocationPathField_LocationFragment = { __typename?: 'Location', id: string, name: string, path?: string | null | undefined, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string }, room?: { __typename?: 'Location', id: string, roomType?: { __typename?: 'RoomType', id: string } | null | undefined } | null | undefined, level?: { __typename?: 'Location', id: string } | null | undefined, group?: { __typename?: 'Location', id: string } | null | undefined, featureType?: { __typename?: 'FeatureType', id: string } | null | undefined };

export const LocationPathField_FeatureTypeFragmentDoc = gql`
    fragment LocationPathField_FeatureType on FeatureType {
  id
  name
  parent {
    id
  }
}
    `;
export const LocationPathField_LocationFragmentDoc = gql`
    fragment LocationPathField_Location on Location {
  id
  name
  path
  displayLocationPath
  type {
    code
    name
  }
  room {
    id
    roomType {
      id
    }
  }
  level {
    id
  }
  group {
    id
  }
  featureType {
    id
  }
}
    `;
export const LocationPathField_GetLocationsDocument = gql`
    query LocationPathField_GetLocations($filter: LocationsFilter!) {
  locations(filter: $filter) {
    ...LocationPathField_Location
  }
}
    ${LocationPathField_LocationFragmentDoc}`;

/**
 * __useLocationPathField_GetLocationsQuery__
 *
 * To run a query within a React component, call `useLocationPathField_GetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationPathField_GetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationPathField_GetLocationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLocationPathField_GetLocationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables> & ({ variables: LocationPathField_GetLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>(LocationPathField_GetLocationsDocument, options);
      }
export function useLocationPathField_GetLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>(LocationPathField_GetLocationsDocument, options);
        }
// @ts-ignore
export function useLocationPathField_GetLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>;
export function useLocationPathField_GetLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LocationPathField_GetLocationsQuery | undefined, LocationPathField_GetLocationsQueryVariables>;
export function useLocationPathField_GetLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>(LocationPathField_GetLocationsDocument, options);
        }
export type LocationPathField_GetLocationsQueryHookResult = ReturnType<typeof useLocationPathField_GetLocationsQuery>;
export type LocationPathField_GetLocationsLazyQueryHookResult = ReturnType<typeof useLocationPathField_GetLocationsLazyQuery>;
export type LocationPathField_GetLocationsSuspenseQueryHookResult = ReturnType<typeof useLocationPathField_GetLocationsSuspenseQuery>;
export type LocationPathField_GetLocationsQueryResult = ApolloReactCommon.QueryResult<LocationPathField_GetLocationsQuery, LocationPathField_GetLocationsQueryVariables>;
export const LocationPathField_GetFeatureTypesDocument = gql`
    query LocationPathField_GetFeatureTypes($filter: FeatureTypesFilter!) {
  featureTypes(filter: $filter) {
    ...LocationPathField_FeatureType
  }
}
    ${LocationPathField_FeatureTypeFragmentDoc}`;

/**
 * __useLocationPathField_GetFeatureTypesQuery__
 *
 * To run a query within a React component, call `useLocationPathField_GetFeatureTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationPathField_GetFeatureTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationPathField_GetFeatureTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLocationPathField_GetFeatureTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables> & ({ variables: LocationPathField_GetFeatureTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>(LocationPathField_GetFeatureTypesDocument, options);
      }
export function useLocationPathField_GetFeatureTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>(LocationPathField_GetFeatureTypesDocument, options);
        }
// @ts-ignore
export function useLocationPathField_GetFeatureTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>;
export function useLocationPathField_GetFeatureTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LocationPathField_GetFeatureTypesQuery | undefined, LocationPathField_GetFeatureTypesQueryVariables>;
export function useLocationPathField_GetFeatureTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>(LocationPathField_GetFeatureTypesDocument, options);
        }
export type LocationPathField_GetFeatureTypesQueryHookResult = ReturnType<typeof useLocationPathField_GetFeatureTypesQuery>;
export type LocationPathField_GetFeatureTypesLazyQueryHookResult = ReturnType<typeof useLocationPathField_GetFeatureTypesLazyQuery>;
export type LocationPathField_GetFeatureTypesSuspenseQueryHookResult = ReturnType<typeof useLocationPathField_GetFeatureTypesSuspenseQuery>;
export type LocationPathField_GetFeatureTypesQueryResult = ApolloReactCommon.QueryResult<LocationPathField_GetFeatureTypesQuery, LocationPathField_GetFeatureTypesQueryVariables>;